import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

import {
	FCM_EXPERIMENT_DASHBOARD_TABS,
	FCM_EXPERIMENT_HELLO_WORLD,
	FCM_EXPERIMENT_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS_V03,
} from './config';

export const {
	FcmExperimentsContext: StarterDashboardV2PageFcmExperimentsContext,
	FcmExperimentsProvider: StarterDashboardV2PageFcmExperimentsContextProvider,
	useFcmExperiments: useStarterDashboardV2PageFcmExperiments,
	useAsyncFcmExperiments: useAsyncStarterDashboardV2PageFcmExperiments,
	prefetchFcmExperiments: prefetchStarterDashboardV2PageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'StarterDashboardV2PageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {
		helloExperiment: FCM_EXPERIMENT_HELLO_WORLD,
		dashboardTabsExperiment: FCM_EXPERIMENT_DASHBOARD_TABS,
		shareRecommendationsExperiment: FCM_EXPERIMENT_STARTER_EXPERIENCE_SHARE_RECOMMENDATIONS_V03,
	},
	prefetch: true,
});

export type StarterDashboardV2PageFcmExperimentsState = ReturnType<typeof useAsyncStarterDashboardV2PageFcmExperiments>;
export type StarterDashboardV2PageFcmExperiments = LoadedStateData<StarterDashboardV2PageFcmExperimentsState>;
